import React, { useContext } from "react";
import { Empty, Skeleton } from "antd";
import { FaMailBulk } from "react-icons/fa";
import InfoContext from "./reducer";

const ContactCard = () => {
  const { state } = useContext(InfoContext);

  if (state.loading) return <Skeleton active />;

  const contactData = state[`${state.memberType}Contact`] || [];

  if (contactData.length === 0) return <Empty className="mb-5" />;

  return (
    <div className="pos-card-icon">
      <span className="icon-top">
        <FaMailBulk />
      </span>
      <table className="pos-table-icon">
        <tbody>
          {contactData.map((n, i) => (
            <tr key={i}>
              <td className="align-top">
                {n.title} {n.title ? " : " : ""}
              </td>
              <td className="align-top">{n.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContactCard;
